<template>
  <TableCommon title="角色信息" :show-custome="false">
    <el-checkbox-group v-model="roles">
      <el-checkbox disabled label="CRM000">售达方</el-checkbox>
      <el-checkbox disabled label="CRM002">收货方</el-checkbox>
      <el-checkbox disabled label="CRM004">收票方</el-checkbox>
    </el-checkbox-group>
  </TableCommon>

</template>

<script>
export default {
  props: {
    role: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      roles: []
    }
  },
  created() {
    this.roles = this.role.map(v => v.RLTYP)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/RoleCheck.vue